import React, { createContext, useContext } from "react";
import { useUsersService } from "../services/Users.service";

let operationsAllowed = {};
const UsersFacadeContext = createContext(operationsAllowed);

export const UsersFacadeProvider = (props: any) => {

  const usersService = useUsersService();

  const getUserListLayout = () => {
    return usersService.getUserListLayout();
  }

  const setUserListLayout = (layout: string) => {
    usersService.setUserListLayout(layout);
  }

  operationsAllowed = {
    getUserListLayout,
    setUserListLayout
  }

  return (
    <UsersFacadeContext.Provider value={operationsAllowed}>
      {props.children}
    </UsersFacadeContext.Provider>
  );
}

export const useUsersFacade = () => {
  return useContext(UsersFacadeContext);
}